var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Recibos")]),_c('lista-recibos',{attrs:{"recibos":_vm.recibos,"loading":_vm.loading,"showCia":false},on:{"recibo-seleccionado":function($event){return _vm.goToRecibo($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }